/**
 * Post Card component optimized for posts in a scrollable row
 */
import { Link } from 'gatsby';
import * as React from 'react';
import styled from 'styled-components';
import { frontendHost } from '../../config';
import DefaultPostImage from './DefaultPostImage';
import PostImage from './PostImage';

const Wrapper = styled.div`
  a {
    display: block;
    text-decoration: none;
  }

  @media (min-width: 768px) {
    a {
      position: relative;

      &::before {
        content: '';
        position: absolute;
        top: -20px;
        left: -20px;
        right: -20px;
        bottom: -20px;
        border-radius: 20px;
        transition: background 0.2s ease;
        z-index: -1;
      }

      &:hover,
      &:focus {
        &::before {
          background: var(--earth-fm--color--dark-beige);
        }
      }
      &:focus-visible {
        outline: 0;

        &::before {
          margin-top: 3px;
          outline: auto;
          outline-color: var(--earth-fm--color--blue);
        }
      }
    }
  }
`;

const ImgWrapper = styled.div`
  margin-bottom: 20px;
`;

const Content = styled.div`
  h3 {
    margin: 0 0 11px;
    font-family: var(--earth-fm--font-family--jakarta);
    font-size: 18px;
    line-height: 1.7;
    font-weight: 600;
  }

  p {
    margin: 0;
    font-size: 18px;
    line-height: 1.7;
    display: -webkit-box;
    -webkit-line-clamp: 2; /* number of lines to show */
    line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;

interface Props {
  data: Queries.PostCardDataFragment;
  className?: string;
}

export default function PostCardAlt({
  data: { title, uri, excerpt, featuredImage, postSettings },
  className = undefined,
}: Props) {
  if (!uri || !title) {
    return null;
  }

  return (
    <Wrapper className={className}>
      <Link to={uri}>
        <ImgWrapper>
          {featuredImage?.node?.localFile?.childImageSharp?.gatsbyImageData ? (
            <PostImage
              imageData={featuredImage?.node?.localFile?.childImageSharp?.gatsbyImageData || null}
              thumbStyle={postSettings?.featuredImageStyle}
              alt={`${title} - ${frontendHost}`}
            />
          ) : (
            <DefaultPostImage alt={`${title} - ${frontendHost}`} />
          )}
        </ImgWrapper>
        <Content>
          <h3>{title}</h3>
          {/* eslint-disable-next-line react/no-danger */}
          {excerpt && <p dangerouslySetInnerHTML={{ __html: excerpt }} />}
        </Content>
      </Link>
    </Wrapper>
  );
}
